import { Sidebar } from "@/components/Sidebar";
import { BillingBanner } from "@/components/BillingBanner";

export const PageShell = ({ title, subtitle, children, testId }) => (
  <div className="h-screen flex flex-col overflow-hidden">
    <BillingBanner />
    <div className="flex-1 flex overflow-hidden">
      <Sidebar />
      <div className="flex-1 overflow-y-auto scroll-thin bg-white" data-testid={testId}>
        <div className="max-w-4xl px-8 py-8">
          <h1 className="font-heading text-2xl font-bold text-gray-900">{title}</h1>
          {subtitle && <p className="text-sm text-gray-500 mt-1 mb-6">{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  </div>
);
